import { z } from "zod";
import { AccountUserSchema } from "./AccountUser";
import { BaseChangelogSchema } from "./Changelog";

export const TaskChangelogSchema = BaseChangelogSchema.extend({
  accountUser: AccountUserSchema.nullable(),
});
export const PartialTaskChangelogSchema = TaskChangelogSchema.deepPartial();

export type PartialTaskChangelog = z.infer<typeof PartialTaskChangelogSchema>;

export type TaskChangelog = z.infer<typeof TaskChangelogSchema>;
